import { render, staticRenderFns } from "./EditAsset.vue?vue&type=template&id=4c0847b2&scoped=true&"
import script from "./EditAsset.vue?vue&type=script&lang=js&"
export * from "./EditAsset.vue?vue&type=script&lang=js&"
import style0 from "./EditAsset.vue?vue&type=style&index=0&id=4c0847b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0847b2",
  null
  
)

export default component.exports